SupportGetawaysBookingStatusAndNotesPresentation=
	editable:
		status: "Booked"
		notes:  "You can cancel this reservation anytime before cancellation date listed in fine print."
	not_editable:
		available:
			status: "Booked"
			notes: ""
		non_cancellable:
			status: "Booked"
			notes: "You may no longer edit this booking because the cancellation window has passed"
		redeemed:
			status: "Used on <span class='localtime'>{{redeemed_date}}</span>"
			notes: ""
		expired:
			status: "Reservation has passed"
			notes: ""
		expired_redeemed:
			status: "Reservation has passed"
			notes: ""
		expired_unredeemed:
			status: "Reservation has passed"
			notes: ""

module.exports = SupportGetawaysBookingStatusAndNotesPresentation
